<template>
  <div class="main">
    <div class="content">
      <div class="title"></div>
      <div class="text">
        <h3>--规则介绍--</h3>
        <p>唤醒梦想，助梦亚运！</p>
        <p>为打造一届充满情怀的亚运盛会，让更多公众通过新公益的模式参与到杭州亚运会的筹备中来，杭州亚组委于2019年12月15日正式启动“寻找2022个亚运梦想”大型公益行动。</p>
        <p>中国工商银行作为杭州亚运会官方指定 “联合助梦方”之一，从2019年底至2020年底，将搭建“寻梦通道”，在全球范围内“寻梦”。只要您的梦想与亚运有关，只要您对梦想的坚持一如既往，您便可以通过文字、视频、音频、图画等任何您想到的形式将您的梦想告诉我们。我们将在所有亚运梦想中进行甄选，对最终入选的亚运梦想，我们将在第一时间联系您，并以亚运的名义为您圆梦。</p>
        <p>我们坚信，每个梦想都值得被尊重。来吧，唤醒您的梦想，让您的梦想汇聚成亚运梦想的“星空”！</p>
        <div class="button" @click="goInfo">提交我的梦想</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      bgHeight: 0
    }
  },
  methods: {
    goInfo: function () {
      this.$router.push({path: '/info'})
    }
  },
  created() {
    this.bgHeight = document.body.clientHeight
  }
}
</script>
<style scoped>
.main {
  width: 100%;
  height: 100%;
  position: relative;
}
.content {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.title {
  width: 100%;
  height: 3rem;
  background: url('../assets/images/banner.jpg') no-repeat;
  background-size: cover;
  background-position: center -1.9rem;
  position: absolute;
  top: 0;
  border-bottom: 0.5rem solid #fff;
}
.text {
  width: 100%;
  height: 100%;
  background: url('../assets/images/watermark.png');
  background-position: 0 3.5rem;
  background-size: contain;
  box-sizing: border-box;
  padding: 3rem 0.75rem 0;
}
.text h3 {
  font-size: 0.38rem;
  color: #b91b21;
  text-align: center;
  margin: 0.5rem 0;
}
.text p {
  font-size: 0.22rem;
  color: #242323;
  line-height: 0.36rem;
  text-indent:2em;
  margin: 0;
}
.button {
  width: 100%;
  height: 1.3rem;
  color: #fff;
  font-size: 0.46rem;
  text-align: center;
  line-height: 1.3rem;
  margin: 1.1rem auto 0;
  background: url('../assets/images/red-button.png') no-repeat;
  background-size: cover;
  background-position: center;
}
</style>